const responseFail = (response) => {
    const messages = document.getElementById('alert-payment-messages');
    messages.innerHTML = '';

    const errors = response.responseJSON.data.meta.errors;

    const elErrorCustom = document.createElement('div');
    elErrorCustom.setAttribute('class', 'alert alert-danger');
    elErrorCustom.innerHTML = response.responseJSON.message;
    messages.appendChild(elErrorCustom);

    Object.keys(errors).forEach((key) => {
        errors[key].forEach((element) => {
            const elError = document.createElement('div');
            elError.setAttribute('class', 'alert alert-danger');
            elError.innerHTML = element;
            messages.appendChild(elError);
        });
    });
};


const requestSuccess = () => {
    $('#form-payment-new').trigger('reset');

    $('.edit-modal').modal('hide');
    $('#responseModal').modal();
    $('#overlay').removeClass('d-none');

    setTimeout(() => {
        location.reload();
    }, 0);
};

const retryPurchase = (purchaseId, params, closureDone = response => response, closureFail = response => response) => {
    $.ajax({
        url: `/wp-json/actions/robox-api/purchases/${purchaseId}/retry`,
        method: 'PUT',
        data: params,
    })
        .done((response) => {
            closureDone(response);
        })
        .fail((response) => {
            closureFail(response);
        })
        .always(() => {
            $('#save-card').html('SALVAR').removeAttr('disabled');
        });
};

const purchasesSubscription = (subscriptionId, closureDone = response => response) => {
    $.ajax({
        url: `/wp-json/actions/robox-api/subscriptions/${subscriptionId}/purchases`,
        method: 'GET',
    })
        .done((response) => {
            closureDone(response)
        });
};

const tryToChargeTheLastPurchaseAgain = (subscriptionId, cardId) => {
    const actionToCallRetryPurchase = (response) => {
        const lastPurchase = response.data[0];

        if (lastPurchase.attributes.status === 'failed') {
            const params = {
                'card': {
                    'card_id': cardId,
                },
                payment_method: 'credit_card',
            };

            retryPurchase(
                lastPurchase.attributes.id,
                params,
                requestSuccess,
                (response) => {
                    responseFail(response);
                    $('#save-card').html('SALVAR').removeAttr('disabled');
                }
            )
        } else {
            requestSuccess();
        }
    }

    purchasesSubscription(subscriptionId, actionToCallRetryPurchase);
};

const updateSubscription = (params) => {
    var subscriptionId = $('.payment-subscription-id').text();

    $.ajax({
        url: `/wp-json/actions/robox-api/subscriptions/${subscriptionId}`,
        method: 'PUT',
        data: params,
    })
        .done((response) => {
            tryToChargeTheLastPurchaseAgain(response.attributes.id, response.attributes.card_id)
        })
        .fail((response) => {
            responseFail(response);
            $('#save-card').html('SALVAR').removeAttr('disabled');
        });
};

const createCard = (params) => {
    $.ajax({
        url: '/wp-json/actions/robox-api/cards',
        method: 'POST',
        data: params,
    })
        .done((response) => {
            const params = {
                card: {
                    card_id: response.attributes.id,
                },
                payment_method: 'credit_card',
            };

            updateSubscription(params);
        })
        .fail((response) => {
            responseFail(response);
            $('#save-card').html('SALVAR').removeAttr('disabled');
        });
};

const submitCreditCard = () => {
    document.getElementById('save-card').addEventListener('click', (event) => {
        const elButtonSave = event.target;
        elButtonSave.innerHTML = 'SALVANDO...';
        elButtonSave.setAttribute('disabled', 'disabled');

        if($('#div-cards input[name=card]:checked').val() === 'new') {
            $('#form-payment-new').trigger('submit');
        } else {
            const params = {
                card: {
                    card_id: $('#div-cards input[name="card"]:checked').val(),
                },
                payment_method: 'credit_card',
            };

            updateSubscription(params);
        }
    });

    $('#form-payment-new').submit(function (event) {
        event.preventDefault();
        const form = event.target;
        const params = {
            number: form.number.value.replace(/\D/g, ''),
            holder_name: form.holder_name.value,
            exp_month: form.exp_month.value,
            exp_year: form.exp_year.value,
            cvv: form.cvv.value,
            brand: form.brand.value,
            payment_method: 'credit_card',
        }

        createCard(params);
    });
};

export default () => {
    submitCreditCard();
};



// WEBPACK FOOTER //
// ./scripts/routes/views/partials/dashboard-pages/script-fraction/createOrUpdateCreditCard.js